import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CustomerModel }           from '../customers/models/customer';
import { EditComponent }           from '../table/cell-components/actions/edit.component';
import { MessagesService }         from '../messages/messages.service';
import { Table }                   from '../table/types/table';
import { TableQueryParameters }    from '../table/types/table-query-parameters';
import { TableService }            from '../table/table.service';
import { VehicleModel }            from './models/vehicle';
import { VehiclesInspectionModel } from './typings/vehicles.inspection';
import { VehiclesService }         from './vehicles.service';

@Component({
  selector   : 'wor-vehicle-inspections',
  template: require('./vehicle.inspections.component.html')
})
export class VehicleInspectionsComponent implements OnInit {
  @Input() customer   : CustomerModel                  = {} as CustomerModel;
  @Input() inspections: Array<VehiclesInspectionModel> = [];
  @Input() vehicle    : VehicleModel                   = {} as VehicleModel;

  collapsed = false;

  tableSettings : Table = {
    cache: {
      enabled: true,
      key    : this.vehiclesService.inspectionsTableCacheKey
    },
    columns: [
      {
        field : 'inspection_number',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.INSPECTION_NUMBER')
        },
      },
      {
        field : 'inspection_date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'inspection_status',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'inspectionStatus'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: ( inspection : VehiclesInspectionModel ) => this.view(inspection)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('INSPECTIONS_SPACE.NO_INSPECTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : this.tableService.getCachedPaging(this.vehiclesService.inspectionsTableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => this.vehiclesService.getInspectionsCount(this.vehicle)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: this.tableService.setSortingFromCache(this.vehiclesService.inspectionsTableCacheKey, {
      direction: 'asc',
      field    : 'inspection_date'
    })
  };

  constructor (
    private messagesService : MessagesService,
    private router          : UIRouter,
    private tableService    : TableService,
    private translateService: TranslateService,
    private vehiclesService : VehiclesService
  ) {}

  ngOnInit () : void {
    this.collapsed = !this.inspections.length;
  }

  get ( params : TableQueryParameters ) : Promise<Array<VehiclesInspectionModel>> {
    return this.vehiclesService.getInspections(this.vehicle, params)
      .then(( inspections : Array<VehiclesInspectionModel> ) => {
        this.inspections = inspections;

        return inspections;
      })
      .catch(error => {
        this.messagesService.error(error);

        return this.inspections;
      });
  }

  view ( inspection : VehiclesInspectionModel ) : void {
    this.router.stateService.go('app.inspection', {
      customer_id: inspection.customer_id,
      id         : inspection.id,
      vehicle_id : inspection.vehicle_id
    });
  }
}
